export const BASE_API_URL = process.env.APP_URL_API;
export const APP_NAME = process.env.APP_NAME || '';
export const APP_VERSION = process.env.APP_VERSION || '';
export const APP_URL = process.env.APP_URL_CLIENT || '';
export const WHATSAPP_API_HREF = process.env.WHATSAPP_API_HREF || '';

export const URL_PATHS = {
  API_AUTH_V1: `${BASE_API_URL}/api/v1/auth`,
  API_USER_V1: `${BASE_API_URL}/api/v1/user`,
  API_CATALOG_V1: `${BASE_API_URL}/api/v1/catalog`,
  API_ORDER_V1: `${BASE_API_URL}/api/v1/order`,
  API_SETTING_V1: `${BASE_API_URL}/api/v1/setting`,
  APP_URL_CLIENT: APP_URL,
};

export const API_KEY_VALUES = {
  CLIENT: process.env.CLIENT_API_KEY,
  COUNTRY_KEY: process.env.COUNTRY_KEY,
};
